import { render } from "./Ortho3dSideBar.vue?vue&type=template&id=2d4a4c76&scoped=true"
import script from "./Ortho3dSideBar.vue?vue&type=script&lang=js"
export * from "./Ortho3dSideBar.vue?vue&type=script&lang=js"

import "./Ortho3dSideBar.vue?vue&type=style&index=0&id=2d4a4c76&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d4a4c76"]])

export default __exports__